import { connect } from "react-redux";
import type { RootState } from "@/store/store";

export const withCurrentAccount = () => {
  const mapStateToProps = (state: RootState) => ({
    currentAccount: state.currentAccount,
  });
  return connect(mapStateToProps);
};
